module.exports = __webpack_public_path__ + "img/tramitacionpracticas.658ba564.png";